import React from 'react'
import type { EquifaxScoreModel } from '../../equifax-credit-report'

type ScoreProps = { model: EquifaxScoreModel }

const Score = ({ model }: ScoreProps) => {
  const scoreColor = model?.score >= 680 ? 'text-success' : 'text-danger'

  return (
    <div className="cr-scoring" >
      {model.rejects?.map(({ code }) => <div key={code} className="cr-reject score">Score: Reject ({code})</div>)}
      {model.score ? <>
        <div className="score">
          <span className={scoreColor}>Score: {model.score}</span>
        </div>
        <div className='mb-3'>
          {model.reasons?.map(r =>
            <div key={r.code} className='my-2'>
              <span className='text-secondary fw-bold'>{r.code}</span>
              <span className='text-secondary'> | {r.description}</span>
            </div>)
          }
        </div>
      </> : null}
    </div >
  )
}

export default Score